/**
 * Changement de mot de passe OBLIGATOIRE à la connexion (quand `must_change_password` est vrai,
 * posé par le super-admin via « Changer le mot de passe » avec l'option « Exiger… »).
 * Overlay bloquant tant que l'utilisateur n'a pas défini un nouveau mot de passe.
 */
import { useState } from 'react';
import { toast } from 'sonner';
import { authApi } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/kit';
import { CavoramaLogo } from '../../components/CavoramaLogo';

export default function ForcePasswordChange() {
  const { user, refreshUser } = useAuth();
  const [current, setCurrent] = useState('');
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  if (!user || !user.must_change_password) return null;

  const valid = current && pw.length >= 8 && pw === confirm;
  const submit = async () => {
    setBusy(true);
    try {
      await authApi.updateProfile({ current_password: current, password: pw });
      toast.success('Mot de passe mis à jour');
      await refreshUser();
    } catch (e) { toast.error(e.message || 'Échec de la mise à jour'); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center p-4 bg-black/50" data-testid="force-password-change">
      <div className="bg-paper border border-hair rounded-lg p-6 w-full max-w-md">
        <CavoramaLogo className="h-7 mb-4" />
        <h2 className="font-title text-2xl mb-1">Nouveau mot de passe requis</h2>
        <p className="text-sm text-n600 mb-4">Pour votre sécurité, veuillez définir un nouveau mot de passe avant de continuer.</p>
        <label className="block mb-3"><span className="block text-[13px] text-n700 mb-1">Mot de passe actuel</span>
          <input className="vd-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="force-current" /></label>
        <label className="block mb-3"><span className="block text-[13px] text-n700 mb-1">Nouveau mot de passe</span>
          <input className="vd-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="force-new" /></label>
        <label className="block mb-2"><span className="block text-[13px] text-n700 mb-1">Confirmer</span>
          <input className="vd-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="force-confirm" /></label>
        <p className={`text-xs mb-4 ${valid ? 'text-n500' : 'text-n600'}`}>8 caractères minimum et les deux saisies identiques.</p>
        <Button variant="primary" disabled={!valid || busy} onClick={submit} data-testid="force-submit" className="w-full">
          {busy ? 'Enregistrement…' : 'Définir le mot de passe'}
        </Button>
      </div>
    </div>
  );
}
